import { EntityBase } from "projects/sepidz-web-framework/src/lib/models/entity-base.model";
import { Cost } from "./cost.model";
import { CostGroup } from "./CostGroup.model";

export class CostSpent extends EntityBase {
  public Code: number;
  public Title: string;
  public CostGroupId: number;
  public CostId: number;
  public Amount: number;
  public CostGroup: CostGroup;
  public Cost: Cost;
  public CostGroupTitle: string;
  public CostGroupCode: number;
  public CostTitle: string;
  public Description: string;
  public CostCode: number;
  public CostSpntDate: Date;
  public ShamsiDateTime: string;
  public DeductionForSetelment?: boolean;
  public Subledger?: number;
  public DetailLedger?: number;
  public TrsConcernId?: number;
  public SettlementId?: number;
  public DriverSettlementId?: number;
  public AccVoucherId?: number;
  public AccFixNo?: number;
}
